<template>
    <v-card>
        <v-card-title>Geo Map Settings</v-card-title>

        <v-divider></v-divider>

        <v-card-text style="max-height: calc(75vh - 0px);">

            <v-tabs v-model="tab" color="#ffffff">
                <v-tabs-slider color="#ffffff"></v-tabs-slider>
                <v-tab key="general">General</v-tab>
                <v-tab key="site">Site Filters</v-tab>
                <v-tab key="alarm">Alarm Filters</v-tab>
                <!-- <v-tab key="coverage">Map Coverage Data</v-tab> -->
            </v-tabs>

            <v-tabs-items v-model="tab" class="tab-content-full-height">

                <v-tab-item key="general">
                    <v-container class="fill-height" style="display: block;" fluid>
                        <v-row dense>
                            <v-col cols="12" md="6">
                                <v-list rounded dense color="#303030">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <v-autocomplete class="mt-2" :items="mapThemes" v-model="$props.generalSettings.mapTheme" label="Map Theme" color="#c42111" outlined hide-details>
                                                    <template v-slot:selection="{item}">
                                                        <div style="width: 60px; height: 48px; padding-top: 5px;">
                                                            <v-img :src="googleMapStylesThumbnails[item.value]" width="50" height="40" v-if="googleMapStylesThumbnails[item.value]" />
                                                            <v-icon x-large v-else>mdi-image-broken-variant</v-icon>
                                                        </div>
                                                        <span v-text="item.text" />
                                                    </template>
                                                    <template v-slot:item="{item}">
                                                        <div style="width: 60px; height: 48px; padding-top: 5px;">
                                                            <v-img :src="googleMapStylesThumbnails[item.value]" width="50" height="40" v-if="googleMapStylesThumbnails[item.value]" />
                                                            <v-icon x-large v-else>mdi-image-broken-variant</v-icon>
                                                        </div>
                                                        <span v-text="item.text" />
                                                    </template>
                                                </v-autocomplete>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <v-autocomplete class="mt-2" :items="mapTypes" v-model="$props.generalSettings.mapType" @change="mapTypeChange" label="Map Type" color="#c42111" :disabled="$props.generalSettings.mapTheme != 'standard'" outlined hide-details />
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>Roads</v-list-item-title>
                                            <v-slider style="display: block;" dark v-model="$props.generalSettings.featureDensityRoads" :tick-labels="googleMapStyleModifierLabels" :disabled="featureDensityDisabled" :max="3" step="1" ticks color="#c42111" tick-size="4"></v-slider>
                                            <v-list-item-title>Landmarks</v-list-item-title>
                                            <v-slider style="display: block;" dark v-model="$props.generalSettings.featureDensityLandmarks" :tick-labels="googleMapStyleModifierLabels" :disabled="featureDensityDisabled" :max="3" step="1" ticks color="#c42111" tick-size="4"></v-slider>
                                            <v-list-item-title>Labels</v-list-item-title>
                                            <v-slider style="display: block;" dark v-model="$props.generalSettings.featureDensityLabels" :tick-labels="googleMapStyleModifierLabels" :disabled="featureDensityDisabled" :max="3" step="1" ticks color="#c42111" tick-size="4"></v-slider>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <v-switch label="Network Category Icons" v-model="$props.generalSettings.networkCategoryIcons" color="#c42111" hide-details />
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <v-switch label="Show Link Directionality" v-model="$props.generalSettings.showLinkDirectionality" color="#c42111" hide-details />
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <v-switch label="Cluster Sites" v-model="$props.generalSettings.clusterSites" color="#c42111" hide-details />
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>

                                </v-list>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>

                <v-tab-item key="site">
                    <v-container class="fill-height" style="display: block;" fluid>
                        
                        <v-row dense>
                            <v-col cols="12" md="6" lg="3">
                                <v-card class="view-filter-card" color="#303030">
                                    <v-card-title>Site Severity Filters</v-card-title>
                                    <v-divider />
                                    <v-card-text style="margin-top: -10px !important;">
                                        <v-checkbox v-model="$props.siteSeverityFilters.critical" label="Critical" :color="geoColors.critical.background" hide-details></v-checkbox>
                                        <v-checkbox v-model="$props.siteSeverityFilters.major" label="Major" :color="geoColors.major.background" hide-details></v-checkbox>
                                        <v-checkbox v-model="$props.siteSeverityFilters.minor" label="Minor" :color="geoColors.minor.background" hide-details></v-checkbox>
                                        <v-checkbox v-model="$props.siteSeverityFilters.observational" label="Observational" :color="geoColors.observational.background" hide-details></v-checkbox>
                                        <v-checkbox v-model="$props.siteSeverityFilters.normal" label="Normal" :color="geoColors.normal.background" hide-details></v-checkbox>
                                        <v-checkbox v-model="$props.siteSeverityFilters.serviceAffecting" label="Service Affecting" color="#c42111" hide-details></v-checkbox>
                                    </v-card-text>
                                </v-card>
                            </v-col>

                            <v-col cols="12" md="6" lg="3">
                                <v-card class="view-filter-card" color="#303030">
                                    <v-card-title>Link Severity Filters</v-card-title>
                                    <v-divider />
                                    <v-card-text style="margin-top: -10px !important;">
                                        <v-checkbox v-model="$props.linkSeverityFilters.critical" label="Critical" :color="geoColors.critical.background" hide-details></v-checkbox>
                                        <v-checkbox v-model="$props.linkSeverityFilters.major" label="Major" :color="geoColors.major.background" hide-details></v-checkbox>
                                        <v-checkbox v-model="$props.linkSeverityFilters.minor" label="Minor" :color="geoColors.minor.background" hide-details></v-checkbox>
                                        <v-checkbox v-model="$props.linkSeverityFilters.observational" label="Observational" :color="geoColors.observational.background" hide-details></v-checkbox>
                                        <v-checkbox v-model="$props.linkSeverityFilters.normal" label="Normal" :color="geoColors.normal.background" hide-details></v-checkbox>
                                        <v-checkbox v-model="$props.linkSeverityFilters.serviceAffecting" label="Service Affecting" color="#c42111" hide-details></v-checkbox>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        
                            <v-col cols="12" md="6">
                                <v-card class="view-filter-card" color="#303030">
                                    <v-card-title style="display: inline-block;">Site Tag Filters</v-card-title>
                                    <div class="active-filter-count" v-if="$props.siteTagFilters.length">{{$props.siteTagFilters.length}}</div>
                                    <v-divider />
                                    <v-card-text>
                                        <v-row>
                                            <v-col cols="12" md="6">
                                                <v-text-field dense prepend-inner-icon="mdi-magnify" color="#c42111" outlined label="Site Tag Search" v-model="siteTagSearch" />
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <v-btn class="mr-2 mt-1" color="#424242" @click="selectAll('siteTags', 'all')">All</v-btn>
                                                <v-btn class="mr-0 mt-1" color="#424242" @click="selectAll('siteTags', 'none')">None</v-btn>
                                            </v-col>
                                        </v-row>

                                        <v-row dense no-gutters>
                                            <v-col cols="12">
                                                <v-simple-table class="config-table" height="475px" fixed-header>
                                                    <thead>
                                                        <tr>
                                                            <th class="text-left">Site Tag Name</th>
                                                            <th class="text-left">Site Tag Description</th>
                                                            <th class="text-left"># of Sites</th>
                                                            <th class="text-left">Apply</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="siteTag in filteredSiteTags" :key="siteTag.site_group_id">
                                                            <td>{{ siteTag.site_group_name }}</td>
                                                            <td>{{ siteTag.site_group_desc }}</td>
                                                            <td>{{ siteTag.sitesCount }}</td>
                                                            <td>
                                                                <v-checkbox class="default-checkbox" color="#c42111" :input-value="$props.siteTagFilters.includes(siteTag.site_group_id)" @click.stop="siteTagClick(siteTag)" />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </v-simple-table>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-card class="view-filter-card" color="#303030">
                                    <v-card-title style="display: inline-block;">Site Technician Filters</v-card-title>
                                    <div class="active-filter-count" v-if="$props.siteTechnicianFilters.length">{{$props.siteTechnicianFilters.length}}</div>
                                    <v-divider />
                                    <v-card-text>
                                        <v-row>
                                            <v-col cols="12" md="6">
                                                <v-text-field dense prepend-inner-icon="mdi-magnify" color="#c42111" outlined label="Site Technician Search" v-model="siteTechnicianSearch" />
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <v-btn class="mr-2 mt-1" color="#424242" @click="selectAll('siteTechnicians', 'all')">All</v-btn>
                                                <v-btn class="mr-0 mt-1" color="#424242" @click="selectAll('siteTechnicians', 'none')">None</v-btn>
                                            </v-col>
                                        </v-row>

                                        <v-row dense no-gutters>
                                            <v-col cols="12">
                                                <v-simple-table class="config-table" height="475px" fixed-header>
                                                    <thead>
                                                        <tr>
                                                            <th class="text-left">User Name</th>
                                                            <th class="text-left">User Full Name</th>
                                                            <th class="text-left"># of Sites</th>
                                                            <th class="text-left">Apply</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="user in filteredSiteTechnicians" :key="user.user_id">
                                                            <td>{{ user.user_username }}</td>
                                                            <td>{{ user.user_fullname }}</td>
                                                            <td>{{ user.sitesCount }}</td>
                                                            <td>
                                                                <v-checkbox class="default-checkbox" color="#c42111" :input-value="$props.siteTechnicianFilters.includes(user.user_id)" @click.stop="siteTechnicianClick(user)" />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </v-simple-table>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-card class="view-filter-card" color="#303030">
                                    <v-card-title style="display: inline-block;">Site Network Category Filters</v-card-title>
                                    <div class="active-filter-count" v-if="$props.siteNetworkCategoryFilters.length">{{$props.siteNetworkCategoryFilters.length}}</div>
                                    <v-divider />
                                    <v-card-text>
                                        <v-row>
                                            <v-col cols="12" md="6">
                                                <v-text-field dense prepend-inner-icon="mdi-magnify" color="#c42111" outlined label="Network Category Search" v-model="networkCategorySearch" />
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <v-btn class="mr-2 mt-1" color="#424242" @click="selectAll('networkCategories', 'all')">All</v-btn>
                                                <v-btn class="mr-0 mt-1" color="#424242" @click="selectAll('networkCategories', 'none')">None</v-btn>
                                            </v-col>
                                        </v-row>

                                        <v-row dense no-gutters>
                                            <v-col cols="12">
                                                <v-simple-table class="config-table" height="475px" fixed-header>
                                                    <thead>
                                                        <tr>
                                                            <th class="text-left">Network Category Name</th>
                                                            <th class="text-left">Icon</th>
                                                            <th class="text-left"># of Sites</th>
                                                            <th class="text-left">Apply</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="networkCategory in filteredNetworkCategories" :key="networkCategory.network_category_id">
                                                            <td>{{ networkCategory.network_category_name }}</td>
                                                            <td><v-icon :color="networkCategory.network_category_color">{{ networkCategory.network_category_icon }}</v-icon></td>
                                                            <td>{{ networkCategory.sitesCount }}</td>
                                                            <td>
                                                                <v-checkbox class="default-checkbox" color="#c42111" :input-value="$props.siteNetworkCategoryFilters.includes(networkCategory.network_category_id)" @click.stop="networkCategoryClick(networkCategory)" />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </v-simple-table>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>

                        </v-row>

                    </v-container>
                </v-tab-item>

                <v-tab-item key="alarm">
                    <geo-map-advanced-alarm-filters :filters="advancedFilters" :filterValueLists="$props.advancedFiltersValueLists" :alarmGridResources="alarmGridResources" :alarmViews="$props.alarmViews" />
                </v-tab-item>

                <!-- <v-tab-item key="coverage">
                    <map-coverage-files :geoSiteList="geoSiteList" />
                </v-tab-item> -->

            </v-tabs-items>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="$emit('close')">OK</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { GoogleMapStylesThumbnails } from "@/components/GeoMap/GoogleMapStyles";
import GeoMapAdvancedAlarmFilters from "@/components/GeoMap/GeoMapAdvancedAlarmFilters";
import MapCoverageFiles from "@/components/GeoMap/MapCoverageFiles";
export default {
    name: 'GeoMapSettings',
    props: ['generalSettings', 'geoSiteList', 'siteSeverityFilters', 'linkSeverityFilters', 'siteTags', 'siteTagFilters', 'siteTechnicians', 'siteTechnicianFilters', 'networkCategories', 'siteNetworkCategoryFilters', 'advancedFilters', 'advancedFiltersValueLists', 'alarmGridResources', 'alarmViews'],
    components: {
        GeoMapAdvancedAlarmFilters,
        MapCoverageFiles
    },
    data: () => ({
        tab: 0,
        geoColors: {},
        mapTypes: [
            {text: 'Road', value: 'roadmap'},
            {text: 'Terrain', value: 'terrain'},
            {text: 'Satellite', value: 'satellite'},
            {text: 'Hybrid', value: 'hybrid'},
        ],
        mapThemes: [
            {text: 'Standard', value: 'standard'},
            {text: 'Silver', value: 'silver'},
            {text: 'Retro', value: 'retro'},
            {text: 'Dark', value: 'dark'},
            {text: 'Night', value: 'night'},
            {text: 'Aubergine', value: 'aubergine'},
        ],
        googleMapStylesThumbnails: GoogleMapStylesThumbnails,
        googleMapStyleModifierLabels: ['Off', 'Low', 'Medium', 'Full'],
        siteTagSearch: "",
        siteTechnicianSearch: "",
        networkCategorySearch: "",
    }),

    computed: {
        filteredSiteTags() {
            if(!this.siteTagSearch) {
                return this.$props.siteTags;
            }
            let search = this.siteTagSearch.toLowerCase();
            return this.$props.siteTags.filter(st => {
                return ((st.site_group_name.toLowerCase().includes(search)) || (st.site_group_desc.toLowerCase().includes(search)));
            });
        },

        filteredSiteTechnicians() {
            let users = this.$props.siteTechnicians;
            if(!this.siteTechnicianSearch) {
                return users;
            }
            let search = this.siteTechnicianSearch.toLowerCase();
            return users.filter(u => {
                return ((u.user_username.toLowerCase().includes(search)) || (u.user_fullname.toLowerCase().includes(search)));
            });
        },

        filteredNetworkCategories() {
            if(!this.networkCategorySearch) {
                return this.$props.networkCategories;
            }
            let search = this.networkCategorySearch.toLowerCase();
            return this.$props.networkCategories.filter(nc => {
                return (nc.network_category_name.toLowerCase().includes(search));
            });
        },

        featureDensityDisabled() {
            return !(this.$props.generalSettings.mapType == 'roadmap');
        }
    },

    methods: {
        siteTagClick: function(siteTag) {
            if(this.$props.siteTagFilters.includes(siteTag.site_group_id)) {
                // de-select tag
                this.$props.siteTagFilters.splice(this.$props.siteTagFilters.indexOf(siteTag.site_group_id), 1);
            }
            else {
                // select tag
                this.$props.siteTagFilters.push(siteTag.site_group_id);
            }
        },

        siteTechnicianClick: function(user) {
            if(this.$props.siteTechnicianFilters.includes(user.user_id)) {
                // de-select
                this.$props.siteTechnicianFilters.splice(this.$props.siteTechnicianFilters.indexOf(user.user_id), 1);
            }
            else {
                // select
                this.$props.siteTechnicianFilters.push(user.user_id);
            }
        },

        networkCategoryClick: function(networkCategory) {
            if(this.$props.siteNetworkCategoryFilters.includes(networkCategory.network_category_id)) {
                // de-select
                this.$props.siteNetworkCategoryFilters.splice(this.$props.siteNetworkCategoryFilters.indexOf(networkCategory.network_category_id), 1);
            }
            else {
                // select
                this.$props.siteNetworkCategoryFilters.push(networkCategory.network_category_id);
            }
        },

        selectAll: function(filterType, mode) {
            let allValues, filterValues = [];
            if(filterType == 'siteTags') {
                allValues = this.$props.siteTags.map(t => t.site_group_id);
                filterValues = this.$props.siteTagFilters;
            }
            else if(filterType == 'siteTechnicians') {
                allValues = this.$props.siteTechnicians.map(t => t.user_id);
                filterValues = this.$props.siteTechnicianFilters;
            }
            else if(filterType == 'networkCategories') {
                allValues = this.$props.networkCategories.map(n => n.network_category_id);
                filterValues = this.$props.siteNetworkCategoryFilters;
            }

            if(mode == 'all') {
                filterValues.splice(0, filterValues.length);
                allValues.forEach(value => {filterValues.push(value);});
            }
            else if(mode == 'none') {
                filterValues.splice(0, filterValues.length);
            }
        },

        mapTypeChange: function(type) {
            this.$props.generalSettings.featureDensityRoads = 3;
            this.$props.generalSettings.featureDensityLandmarks = 3;
            this.$props.generalSettings.featureDensityLabels = 3;
        },
    },

    created() {
        this.geoColors = this.$store.state.batchConfig.webapp_settings.alarms.alarmColors.geographical;
    },

    mounted() {

    }

  
};
</script>

<style scoped>

    .tab-content-full-height {
        /* height: calc(80vh - 50px); */
        /* height: 100%; */
        height: calc(75vh - 50px);
        overflow-y: auto;
    }

    .view-filter-card {
        /* border: rgba(255, 255, 255, 0.24) solid 1px !important; */
        /* border: black solid 1px !important; */
        height: 100%;
    }

    .config-table {
        border-radius: 3px;
        /* border: pink solid 1px; */
        border: rgba(255, 255, 255, 0.24) solid 1px;
        overflow-y: auto;
        background-color: #303030 !important;
    }
    .config-table thead tr th {
        background-color: #303030 !important;
    }

    .default-checkbox {
        margin: 0px !important;
        padding: 0px !important;
        height: 25px;
    }




    .config-table-label {
        display: block;
        color: #ffffff;
        font-size: 18px;
        margin-bottom: 0.5em;
    }

    .public-switch {
        margin: 0px !important;
        padding: 0px !important;
        height: 25px;
    }

    .favorite-star {
        cursor: pointer;
    }

    .default-checkbox {
        margin: 0px !important;
        padding: 0px !important;
        height: 25px;
    }

    .config-tables-container {
        margin-top: 1em;
    }

    .selected-config-title {
        display: inline-block;
        color: #ffffff;
        font-size: 18px;
    }


    .active-filter-count {
        background-color: #c42111;
        color: #ffffff;
        display: inline-block;
        text-align: center;
        border: gray solid 1px;
        border-radius: 3px;
        padding: 3px 7px;
        vertical-align: super;
    }

</style>
